export default "__VITE_ASSET__D5gLplf3__"